/**
 * Document types, in an officer's words (DEV-98).
 *
 * One list for uploading, refiling and filtering, so a type is called the same
 * thing wherever it appears. The server decides what is accepted.
 */

export const SLOTS_BUSINESS: ReadonlyArray<readonly [string, string]> = [
  ['company', 'Company documents'],
  ['trading-proof', 'Proof of trading address'],
  ['director-proof', "Director's proof of address"],
  ['ubo', 'Beneficial owner documents'],
  ['identity', 'Identity document'],
];

export const SLOTS_PERSONAL: ReadonlyArray<readonly [string, string]> = [
  ['address-proof', 'Proof of address'],
  ['identity', 'Identity document'],
];

/** Filed by the platform (a screening report); never chosen by a person. */
export const PROVIDER_ONLY_TYPES: ReadonlySet<string> = new Set(['company-screening']);

const LABELS: Readonly<Record<string, string>> = {
  ...Object.fromEntries([...SLOTS_BUSINESS, ...SLOTS_PERSONAL]),
  'company-screening': 'Company screening report',
  // Records from the KYC provider carry a document type rather than a slot.
  PASSPORT: 'Passport',
  NATIONAL_ID: 'National ID',
  DRIVING_LICENCE: 'Driving licence',
  PROOF_OF_ADDRESS: 'Proof of address',
  BANK_STATEMENT: 'Bank statement',
  REGISTRY_EXTRACT: 'Registry extract',
};

export function documentTypeLabel(type: string): string {
  return LABELS[type] ?? type.replace(/[-_]/g, ' ').toLowerCase().replace(/^\w/, (c) => c.toUpperCase());
}

/** The types a person may file a document under on this client. */
export function fileableTypes(isBusiness: boolean): ReadonlyArray<readonly [string, string]> {
  return isBusiness ? SLOTS_BUSINESS : SLOTS_PERSONAL;
}
